// extracted by mini-css-extract-plugin
export default {"Container":"Title_Container__JwChb"};